import React, { useState } from "react";
import PropTypes from "prop-types";
import { initials } from "./utils";

// Square tile for a company/outlet logo. Unlike SourceAvatar (object-fit: cover, meant
// for photo headshots), this CONTAINS the logo inside a fixed frame with a quiet backdrop —
// a wide wordmark (e.g. "Business Insider") letterboxes instead of being cropped/stretched
// into an unreadable fragment. Falls back to initials on a solid tint, both when there is
// no image and when the image fails to load.
function LogoTile({
  imageUrl,
  name,
  size,
  borderRadius = 10,
  backdrop = "#F5F9FF",
  fallbackBackground = "#e5e7eb",
  fallbackColor = "#6b7280",
  fontSize,
  fontWeight = 600,
}) {
  const [imgError, setImgError] = useState(false);
  const box = { width: size, height: size, borderRadius, flexShrink: 0 };

  if (imageUrl && !imgError) {
    return (
      <div
        style={{
          ...box,
          background: backdrop,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          padding: 4,
          boxSizing: "border-box",
        }}
      >
        <img
          src={imageUrl}
          alt={name}
          onError={() => setImgError(true)}
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        ...box,
        background: fallbackBackground,
        color: fallbackColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight,
        fontSize,
      }}
    >
      {initials(name)}
    </div>
  );
}

LogoTile.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number.isRequired,
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backdrop: PropTypes.string,
  fallbackBackground: PropTypes.string,
  fallbackColor: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.number,
};

export default LogoTile;
